'use client';

import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation as t } from '../../../hooks/useTranslation';
import { EpStepContent } from '../components';
import { EpFormInput } from '../components/EpFormInput';

export default function PatientIdentificationInput({
  translations,
  isPharmacy = false,
}: {
  translations: string[];
  isPharmacy?: boolean;
}) {
  const {
    setValue,
    unregister,
    formState: { errors },
  } = useFormContext();

  const PersonValue = useWatch({ name: 'person.inputValue' });
  const NoId = useWatch({ name: 'noId' });

  const personType = useWatch({ name: 'personType' });
  const checkIfIsPersonValid =
    (PersonValue === 'true' || PersonValue === undefined) && !!NoId;
  const checkIfIsPersonType =
    personType?.inputValue && personType?.inputValue !== '1';
  const isVisible = checkIfIsPersonValid || checkIfIsPersonType || isPharmacy;

  function handleChange() {
    setValue('formUtils.stepNeedReview', '2');
    unregister('unitId.inputValue');
    unregister('unitId.inputLabel');
  }

  if (!isVisible) return null;

  return (
    <>
      <EpStepContent.Label
        label={t(translations, 'Identification number') + ' *'}
      >
        <EpFormInput
          inputOnChangeFunc={handleChange}
          inputRequired
          inputType="text"
          inputName="patientIdentification"
          inputPlaceholder={t(
            translations,
            'Any number or document identifying the person',
          )}
          translations={translations}
          inputIsFullWidth
          inputWithError={!!errors[`patientIdentification`]}
          errorMessage={t(translations, '* Required Fied')}
          inputMaxLength={30}
        />
      </EpStepContent.Label>
      {/* <EpErrorMessage inputName="patientIdentification" /> */}
    </>
  );
}
